import { render, staticRenderFns } from "./ListarModalidade.vue?vue&type=template&id=5d5f3763"
import script from "./ListarModalidade.vue?vue&type=script&lang=js"
export * from "./ListarModalidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports